export const getFileExtension = (file) => {
  // Default extension
  let ext = 'jpg';
  
  try {
    // Method 1: Extract from file name
    if (file.name && typeof file.name === 'string' && file.name.includes('.')) {
      const nameParts = file.name.split('.');
      if (nameParts.length > 1) {
        ext = nameParts.pop().toLowerCase();
        return ext;
      }
    }
    
    // Method 2: Derive from MIME type
    if (file.type && typeof file.type === 'string') {
      const typeMap = {
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/bmp': 'bmp',
        'image/tiff': 'tiff',
        'image/svg+xml': 'svg'
      };
      
      const mimeType = file.type.toLowerCase();
      ext = typeMap[mimeType] || 'jpg';
    }
    
  } catch (error) {
    console.warn('Error extracting file extension:', error);
  }

  return ext;
};

// Downscale + recompress an image File/Blob client-side before upload.
// Shared by PhotoCaptureDialog and FragileCheckDialog (scan-photo capture flows).
export const compressImage = (file, quality = 0.8, maxWidth = 1024) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      let { width, height } = img;
      if (width > maxWidth) {
        height = (height * maxWidth) / width;
        width = maxWidth;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(resolve, 'image/jpeg', quality);
    };

    img.src = URL.createObjectURL(file);
  });
};